import React from "react";
import { Icon, Stack } from "@bookingcom/bui-react";
// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useStore } from "../../../store";
import { assert, invariant } from "../../../utils/assert";
import { ancillaryNames } from "../../../ancillaries/utils/ancillaryNames";

import { UIOrderExtras, UIOrderProductType, UIOrderCheckedInBaggage } from "@flights/types";
import { useI18n, t } from "@bookingcom/lingojs-react";
import useFormatPrice from "../../../hooks/useFormatPrice";
import { getPassengerFullNameByReference } from "../../../store/selectors/passengers";
import { productIcons } from "@flights/branded-fares";
import useInsuranceServerSide from "../../../hooks/useInsuranceServerSide";

type Props = {
  ancillaries: UIOrderExtras;
};

const AncillaryBreakdown: React.FunctionComponent<Props> = (props) => {
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();
  const i18n = useI18n();
  const { formatPrice } = useFormatPrice();
  const { travelInsuranceContent } = useInsuranceServerSide(true);

  const { order } = store.order;
  assert(order, "No order");

  const { ancillaries } = props;
  assert(ancillaries, "No ancillaries");

  return (
    <Stack.Item>
      <Stack gap={4}>
        {Object.keys(ancillaries).map((productType: UIOrderProductType, index) => {
          const product: UIOrderExtras[typeof productType] = ancillaries[productType];
          invariant(product);
          const IconSVG = productIcons[productType];
          switch (productType) {
            case "checkedInBaggage": {
              const checkedInBaggage = product as UIOrderCheckedInBaggage;
              return (
                <React.Fragment key={index}>
                  {checkedInBaggage.travelerBaggages.map((passengerBag, index) => {
                    const passengerName = getPassengerFullNameByReference(
                      i18n,
                      passengerBag.travellerReference,
                      order.passengers
                    );
                    return (
                      <Stack.Item key={index}>
                        <Stack direction="row">
                          {IconSVG && <Icon svg={IconSVG} size="large" />}
                          {i18n.trans(
                            t("flights_ancillary_pb_generic_variable", {
                              variables: {
                                // eslint-disable-next-line @typescript-eslint/naming-convention -- this line was auto generated, hence fix the issue timely
                                Ancillary_name: i18n.trans(ancillaryNames(productType)),
                                // eslint-disable-next-line @typescript-eslint/naming-convention -- this line was auto generated, hence fix the issue timely
                                First_name: passengerName
                              }
                            })
                          )}
                          {formatPrice(passengerBag.price.total)}
                        </Stack>
                      </Stack.Item>
                    );
                  })}
                </React.Fragment>
              );
            }

            case "seatMapSelection": {
              return (
                <Stack.Item key={index}>
                  <Stack direction="row">
                    {IconSVG && <Icon svg={IconSVG} size="large" />}
                    {i18n.trans(
                      ancillaryNames(productType, {
                        num_exception:
                          store.cartDetails.cartDetails?.passengers.length || store.order.order?.passengers.length
                      })
                    )}
                    {formatPrice(product.price.total)}
                  </Stack>
                </Stack.Item>
              );
            }
            case "travelInsurance":
              return (
                <Stack.Item key={index}>
                  <Stack direction="row">
                    {IconSVG && <Icon svg={IconSVG} size="large" />}
                    {travelInsuranceContent?.header}
                    {formatPrice(product.price.total)}
                  </Stack>
                </Stack.Item>
              );

            default:
              return (
                <Stack.Item key={index}>
                  <Stack direction="row">
                    {IconSVG && <Icon svg={IconSVG} size="large" />}
                    {i18n.trans(ancillaryNames(productType))}
                    {formatPrice(product.price.total)}
                  </Stack>
                </Stack.Item>
              );
          }
        })}
      </Stack>
    </Stack.Item>
  );
};

export default AncillaryBreakdown;
